import React, { useEffect, useState } from "react";
import { createScrollHandler } from "../../utils/scrollToSection";
import { downloadCvPdf } from "../../cv/downloadCvPdf";
import { getCvDownloadCount, trackCvDownload } from "../../cv/trackCvDownload";
import { reportError } from "../../monitoring/reportError";

const HERO_BG_1 = `${process.env.PUBLIC_URL}/assets/images/img_bg_1.webp`;
const HERO_BG_2 = `${process.env.PUBLIC_URL}/assets/images/img_bg_2.webp`;

const Home = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState("");
  const [downloadCount, setDownloadCount] = useState(null);
  const [loadSecondSlide, setLoadSecondSlide] = useState(false);

  useEffect(() => {
    getCvDownloadCount().then(setDownloadCount);
  }, []);

  useEffect(() => {
    const loadSecond = () => setLoadSecondSlide(true);
    let idleId;
    let timeoutId;

    if (typeof window.requestIdleCallback === "function") {
      idleId = window.requestIdleCallback(loadSecond, { timeout: 2500 });
    } else {
      timeoutId = window.setTimeout(loadSecond, 1200);
    }

    return () => {
      if (idleId != null && typeof window.cancelIdleCallback === "function") {
        window.cancelIdleCallback(idleId);
      }
      if (timeoutId != null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  useEffect(() => {
    const initSlider = () => {
      const $ = window.jQuery;
      if (!$) {
        return;
      }

      const $slider = $("#home .flexslider");
      if (!$slider.length || $slider.data("flexslider")) {
        return;
      }

      $slider.flexslider({
        animation: "fade",
        slideshowSpeed: 5000,
        directionNav: true,
        controlNav: true,
      });
    };

    initSlider();
    const retryTimers = [100, 400, 1000, 2000, 4000].map((delay) =>
      window.setTimeout(initSlider, delay)
    );

    return () => retryTimers.forEach((timer) => window.clearTimeout(timer));
  }, []);

  const handleDownload = async () => {
    setIsGenerating(true);
    setError("");
    try {
      await downloadCvPdf();
      const count = await trackCvDownload();
      if (count != null) {
        setDownloadCount(count);
      }
    } catch (pdfError) {
      reportError(pdfError, { fatal: false, source: "cv.pdf" });
      setError("Could not generate the PDF. Please try again.");
    } finally {
      setIsGenerating(false);
    }
  };

  const handleViewPortfolio = createScrollHandler("work");

  return (
    <section id="home" className="js-fullheight" data-section="home">
      <div className="flexslider js-fullheight">
        <ul className="slides">
          <li
            style={{
              backgroundImage: `url('${HERO_BG_1}')`,
            }}
          >
            <div className="overlay" />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-9 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight hero-slide-col">
                  <div className="slider-text-inner js-fullheight hero-slide-inner">
                    <div className="desc">
                      <h1>
                        Hi! <br />
                        I'm Pradeep
                      </h1>
                      <p>
                        <button
                          type="button"
                          className="btn btn-primary btn-learn"
                          disabled={isGenerating}
                          onClick={handleDownload}
                        >
                          {isGenerating ? "Generating…" : "Download CV"}{" "}
                          <i className="icon-download4" />
                        </button>
                      </p>
                      {error ? (
                        <p className="hero-cv-error" role="alert">
                          {error}
                        </p>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>

          <li
            className="hero-slide--role"
            style={
              loadSecondSlide
                ? { backgroundImage: `url('${HERO_BG_2}')` }
                : undefined
            }
          >
            <div className="overlay" />
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-9 col-md-offset-3 col-md-pull-3 col-sm-12 col-xs-12 js-fullheight hero-slide-col">
                  <div className="slider-text-inner js-fullheight hero-slide-inner">
                    <div className="desc">
                      <h1 className="hero-role">
                        I am a<br />
                        <span className="hero-title-line">Senior Software Engineer</span>
                        <span className="hero-subtitle">
                          Native iOS, cross-platform when it fits
                        </span>
                      </h1>
                      <p>
                        <button
                          type="button"
                          className="btn btn-primary btn-learn"
                          onClick={handleViewPortfolio}
                        >
                          View Portfolio <i className="icon-briefcase3" />
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
        {downloadCount > 0 ? (
          <span
            className="hero-cv-count"
            aria-label={`Downloaded ${downloadCount} ${
              downloadCount === 1 ? "time" : "times"
            }`}
          >
            {downloadCount}x
          </span>
        ) : null}
      </div>
    </section>
  );
};

export default Home;
